import RoleRoute from "./RoleRoute";

export default RoleRoute;
